<script>
  import { guidV4 } from "@itslearning/atlas/generate/guid";
  import { Keys } from "@itslearning/atlas/keyboard/keys";
  import { normalizeKey } from "@itslearning/atlas/keyboard/normalize";
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();

  let panel;

  /** @type {boolean} */
  export let expanded = false;

  /** @type {string} */
  export let id = guidV4();

  /** @type {string} */
  export let title = "This could have been your text";

  /** @type {string} */
  export let descriptionText = '';

  /** @type {'h2'|'h3'}*/
  export let headingLevel = 'h3';

  $: hidden = expanded ? "" : "hidden";

  function keydownHandler(event) {
    const { key } = event;
    const button = event.target;

    const buttons = Array.prototype.slice.call(
      button.parentNode.parentNode.querySelectorAll(".prom-accordion__button")
    );

    const index = buttons.indexOf(button);
    const length = buttons.length;

    switch (normalizeKey(key)) {
      case Keys.UP:
        buttons[(index + length - 1) % length].focus();
        event.preventDefault();

        break;
      case Keys.DOWN:
        buttons[(index + length + 1) % length].focus();
        event.preventDefault();

        break;
      default:
        return;
    }
  }

  function toggle() {
    expanded ? dispatch("closeAccordion") : dispatch("openAccordion");

    expanded = !expanded;
  }
</script>

<svelte:element this={headingLevel} class="prom-accordion__header">
  <button
    type="button"
    aria-controls="{id}-panel"
    aria-expanded={expanded}
    class="prom-accordion__button"
    class:description-text={descriptionText}
    {id}
    on:click={toggle}
    on:keydown={keydownHandler}
  >
    <span class="prom-accordion__title" aria-hidden="true">
      <span class="prom-accordion__icon" />
      <span>{title}</span>
    </span>

    <span class="screen-reader">{descriptionText ? `${title}. ${descriptionText} ` : title}</span>

      {#if descriptionText}
          <span class="prom-accordion__description" aria-hidden="true">{descriptionText}</span>
      {/if}
  </button>
</svelte:element>

<div
  aria-labelledby={id}
  class="prom-accordion__panel"
  id="{id}-panel"
  role="region"
  bind:this={panel}
  {hidden}
>
  <slot />
</div>
